"use client";

import { useRef, useEffect } from "react";
import { useTranslations } from "next-intl";
import { validateEmail } from "@/utils/subscription";
import { popupStore } from "@/stores";

interface EmailAlertProps {
  alertEnabled: boolean;
  setAlertEnabled: (enabled: boolean) => void;
  email: string;
  setEmail: (email: string) => void;
  className?: string;
}

const EmailAlert = ({
  alertEnabled,
  setAlertEnabled,
  email,
  setEmail,
  className
}: EmailAlertProps) => {

  const emailInputRef = useRef<HTMLInputElement>(null);
  const toastT = useTranslations("Toast.Newsletter");

  useEffect(() => {
    if (alertEnabled && emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, [alertEnabled]);

  return (
    <div className={className}>
      {/* Email alert checkbox */}
      <div className="mt-3">
        <div className="flex items-center gap-2 w-full">
          <div
            className={`h-4 w-4 border rounded-[2px] flex items-center justify-center cursor-pointer ${alertEnabled ? "bg-[#004DE3] border-[#004DE3]" : "border-[#004DE3]"}`}
            onClick={() => setAlertEnabled(!alertEnabled)}
          >
            {alertEnabled && (
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6666 3.5L5.24992 9.91667L2.33325 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </div>
          <span
            className="text-[14px] text-primary cursor-pointer"
            onClick={() => setAlertEnabled(!alertEnabled)}
          >
            {toastT("alertLabel")}
          </span>
        </div>
      </div>

      {/* Conditionally render email input */}
      {alertEnabled && (

        <div className="mt-4">
          <input
            ref={emailInputRef}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={toastT("placeholder")}
            className="w-full py-7.5 rounded-[10px] shadow-none bg-[#F4F6F9] border-0 py-4"
            onBlur={() => {
              if (!email.trim()) {
                setAlertEnabled(false);
                return;
              }
              if (!validateEmail(email)) {
                popupStore.setContent(toastT("invalidEmail"), true, 3000)
                setAlertEnabled(false);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default EmailAlert;
